/* eslint no-useless-call: off */
import { AuthData } from "@/types/LocalConfig";
import { FocusSDK, IFocusSDK, isFocusEnv } from "@/utils";
import getVersionBySdk from "./getVersion";
import { NetType } from "@/components/Modals/ChangeNetModal";
import { UAParser } from "ua-parser-js";
import { LOG_DOMAN } from "@/config/name";

const REPORT_OVER_TIME = 1000;
let hasLoad = false;
interface IExtObj {
  [key: string]: string;
}

enum Environment {
  TEST = "test",
  PREV = "prev",
  PROD = "prod"
}

// 是否私有网络
export function isPrivateNet() {
  if ((window as any).__isPrivateNet !== undefined) {
    return (window as any).__isPrivateNet;
  }
  let privateDomain = ["beijing.egov.cn"];
  let currentHost = FocusSDK.getMeMainEntry();

  let findItem = privateDomain.find((item) => {
    return currentHost.indexOf(item) > -1;
  });

  (window as any).__isPrivateNet = !!findItem;

  return !!findItem;
}

function appendUrlExtParams(oldParam: any) {
  let currentParam = oldParam || "";
  const currentUrl = location.href;
  const appendStr = `&currentUrl=${currentUrl}`;
  currentParam += encodeURIComponent(appendStr);
  return currentParam;
}

function getNewExtParams(authData: AuthData, oldParam: any) {
  let currentParam = oldParam || "";
  let array = currentParam.split("$");
  let extParamIndex = array.findIndex((item: any) => {
    if (item.indexOf("ext=") > -1) {
      return true;
    }
    return false;
  });
  if (extParamIndex === -1) {
    return oldParam;
  }
  let extParam = array.splice(extParamIndex, 1)[0].replace("ext=", "") || "";
  extParam = decodeURIComponent(extParam);
  const arrayNew = extParam.split("&");

  const currentArray = arrayNew.map((item: any) => {
    let objArr: any = item.split("=");
    if (objArr.length === 2) {
      if (objArr[0] === "deptName") {
        objArr[1] = authData.teamUserInfo.displayDeptName;
      } else if (objArr[0] === "userId") {
        objArr[1] = authData.userId;
      }
      return `${objArr[0]}=${objArr[1]}`;
    }
    return item;
  });
  array.splice(extParamIndex, 0, `ext=${encodeURIComponent(currentArray.join("&"))}`);
  let rtnStr = array.join("$");
  return rtnStr;
}

let loadCount = 0;
let analysisLogQuery: any[] = [];

function getAppRuntimeEnv(): Promise<any> {
  return new Promise((resolve, reject) => {
    FocusSDK.getAppRuntimeEnv((data: any) => {
      resolve(data);
    }, true);
  });
}

export async function initLogAnalytics(
  account: string,
  authData: AuthData,
  focusSDK: IFocusSDK
): Promise<void> {
  try {
    const { REACT_APP_DUCC_HOST, PUBLIC_URL } = process.env;
    const appRuntimeEnv = await getAppRuntimeEnv();
    const envConfig = appRuntimeEnv.runtimeEnv.config.environments.find(
      (item: any) => item.key === appRuntimeEnv.localConfig.runtimeConfig.env
    ) as any;
    console.log("envConfig~", envConfig);
    const logSwitch = envConfig?.logConfig?.logSwitch || false;
    console.log("logSwitch:", logSwitch);
    let win: any = window;
    win._ducc_host = REACT_APP_DUCC_HOST;
    // if (!logSwitch) {
    //   win.log = function () {};
    //   return;
    // }
    if (hasLoad) {
      if (loadCount === 0) {
        win.oldSendNew = win.JA.tracker.sendNew;
        win.oldSendPost = win.JA.tracker.sendPost;
        win.oldSendToWarriors = win.JA.tracker.sendToWarriors;
      }
      win.JA.tracker.sendNew = function (t: any, e: any) {
        arguments[1] = getNewExtParams(authData, e);
        win.oldSendNew.apply(null, [...arguments]);
      };
      win.JA.tracker.sendPost = function (t: any, e: any, i: any) {
        arguments[1] = getNewExtParams(authData, e);
        win.oldSendPost.apply(null, [...arguments]);
      };
      win.JA.tracker.sendToWarriors = function (t: any, e: any) {
        arguments[1] = getNewExtParams(authData, e);
        win.oldSendToWarriors.apply(null, [...arguments]);
      };
      loadCount++;
      return;
    }
    let jsUrl = `${focusSDK.getMeMainEntry()}/statics/js/joya.js`;
    // if (FocusSDK.getCurrentNetType() === NetType.PRIVATE_NET) {
    //   jsUrl = "https://apps.jzb.beijing.egov.cn/ziwuxianegov/joya.js";
    // }
    hasLoad = true;
    let isBeta = focusSDK.isBeta();
    let version = getVersionBySdk(focusSDK);
    win.jaq = win.jaq || [];
    win.jaq.push(["account", "JA2022_1833789"]);
    win.jaq.push(["domain", "XXX-szy.jdcloud.com"]);
    win.jaq.push(["erp_account", account]);
    // 自定义参数上报
    let extParams: Array<string> = [];
    extParams.push(`deptName=${authData.teamUserInfo.displayDeptName}`);
    extParams.push(`environment=${isBeta ? Environment.TEST : Environment.PROD}`);
    extParams.push(`userId=${authData.userId}`);
    extParams.push(`appId=${authData.teamUserInfo.ddAppId}`);
    extParams.push(`version=${version}`);
    extParams.push(`clientType=${isFocusEnv() ? "pc" : "web"}`);
    extParams.push(`origin=${window?.location?.origin || focusSDK.getMeMainEntry()}`);
    win.jaq.push(["extParams", extParams.join("&")]);
    // 单页面应用方案
    win.jaq.push(["anchorpvflag", "true"]);
    // hash路由方式开启
    // win.jaq.push(['anchorToUri',1]);
    (function () {
      let ja: any = document.createElement("script");
      ja.type = "text/javascript";
      ja.async = true;
      ja.src = jsUrl;
      let s: any = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ja, s);
      ja.onload = () => {
        win._oldSendNew = win.JA.tracker.sendNew;
        win._oldSendPost = win.JA.tracker.sendPost;
        win._oldSendToWarriors = win.JA.tracker.sendToWarriors;
        win.JA.tracker.sendNew = function (t: any, e: any) {
          arguments[1] = appendUrlExtParams(e);
          win._oldSendNew.apply(null, [...arguments]);
        };
        win.JA.tracker.sendPost = function (t: any, e: any, i: any) {
          arguments[1] = appendUrlExtParams(e);
          win._oldSendPost.apply(null, [...arguments]);
        };
        win.JA.tracker.sendToWarriors = function (t: any, e: any) {
          arguments[1] = appendUrlExtParams(e);
          win._oldSendToWarriors.apply(null, [...arguments]);
        };
        while (analysisLogQuery.length) {
          let currentArg = analysisLogQuery.pop();
          // eslint-disable-next-line no-unsafe-optional-chaining
          analysisLog(currentArg?.[0], currentArg?.[1], ...currentArg?.[2]);
        }
      };
    })();
  } catch (e) {
    console.error(e);
  }
}
// log_type1: 业务标识, log_type2: 功能标识
export function analysisLog(log_type1: string, log_type2: string, ...ret: Array<string>): void {
  try {
    let win: any = window;

    if (typeof win.log !== "function") {
      analysisLogQuery.push([log_type1, log_type2, ret]);
      return;
    }
    // 自定义事件至少要有三个参数
    if (!ret.length) {
      ret.push("-1");
    }

    win.log(log_type1, log_type2, ...ret);
    // console.log('自动触发', `${log_type1}|${log_type2}|${ret}`);
  } catch (e) {
    console.error(e);
  }
}

const getLogAnalysisData = (e: MouseEvent) => {
  let target: any = e.target || null;
  while (target) {
    const value = target?.getAttribute && target?.getAttribute("log-analysis-data");
    if (value) {
      return value.split("|");
    }
    if (["body", "document"].includes((target.nodeName || "").toLowerCase())) {
      return [];
    }
    target = target.parentNode;
  }
  return [];
};
// 自定义标签点击上报，上报方式在目标标签添加属性： log-analysis-data='业务标识|功能标识|参数1|参数2|...'
// 其中参数是在自定义事件中的参数顺序即可
export function analysisLogCustom(e: MouseEvent) {
  const logAnalysisData: string[] = getLogAnalysisData(e);
  if (logAnalysisData.length >= 2) {
    analysisLog(...(logAnalysisData as [string, string]));
  }
}

export function analysisComponetUvLog(data: any) {
  try {
    analysisLog("xtbg_pc_components", "uv", typeof data === "string" ? data : JSON.stringify(data));
  } catch (e) {
    console.error("analysisComponetUvLog err", e);
  }
}
const getNetType = () => {
  const nav: any = window.navigator;
  return nav?.connection?.type || nav?.connection?.effectiveType;
};

const getBrowserInfo = () => {
  const win: any = window;
  if (!win._log_browserInfo) {
    const parser = new UAParser();
    const result = parser.getResult();
    const { browser, cpu, os } = result;
    win._log_browserInfo = {
      browser,
      cpu,
      os
    };
  }
  return win._log_browserInfo;
};

export function reportWebPerf(data: any) {
  const { sta_ts, end_ts, htm_ts, dom_ts } = data;
  const browserInfo = getBrowserInfo();
  const { browser, cpu, os } = browserInfo;
  console.log("browserInfo--", browserInfo);
  if (isFocusEnv()) {
    FocusSDK.sendTrackLog({
      type: "FCP",
      data: {
        sta_ts,
        htm_ts,
        dom_ts,
        end_ts
      }
    });
    return;
  }
  try {
    analysisLog(
      "xtbg_web_perf",
      "PAGETTI",
      JSON.stringify({
        sta_ts,
        htm_ts,
        dom_ts,
        end_ts,
        os_n: os.name || "",
        os_v: os.version || "",
        web_n: browser.name || "",
        web_v: browser.version || "",
        cpu: cpu.architecture || "",
        net_type: getNetType(),
        u_net: FocusSDK.isPrivateNet() ? 2 : 1
      })
    );
  } catch (e) {
    console.error("analysisPerf err", e);
  }
}

export function reportServerPerf(data: any) {
  let url: any = data.url;
  const { sta_ts, end_ts, status, f_s, mid, sid } = data;
  const duration = end_ts - sta_ts;
  const resStatus = String(status);
  if ((duration > REPORT_OVER_TIME && resStatus === "200") || resStatus.indexOf("5") > -1) {
    url = new URL(url, FocusSDK.getMeMainEntry());
    const origin = url.origin;
    url = url.toString().replace(origin, "");
    const net_type = getNetType();
    console.log(`服务端接口上报: ${url}耗时${duration}毫秒`);
    // if (isFocusEnv()) {
    //   FocusSDK.sendTrackLog({
    //     type: "REQUEST",
    //     data: {
    //       sta_ts,
    //       end_ts,
    //       url,
    //       f_s,
    //       status
    //     }
    //   });
    //   return;
    // }
    try {
      analysisLog(
        "xtbg_pc_perf",
        "REQUEST",
        JSON.stringify({
          sta_ts,
          end_ts,
          url,
          f_s,
          status,
          net_type,
          mid,
          sid,
          u_net: FocusSDK.isPrivateNet() ? 2 : 1,
          c_type: isFocusEnv() ? 1 : 2
        })
      );
    } catch (e) {
      console.error("analysisPerf err", e);
    }
  }
}

export function reportNetCheckResult(data: any) {
  try {
    const { url, f_s, up1_et, up2_et, up3_et, c_r, status } = data;
    console.log("data---", data);
    analysisLog(
      "xtbg_pc_net",
      "CHECKRESULT",
      JSON.stringify({
        url,
        f_s,
        up1_et,
        up2_et,
        up3_et,
        c_r,
        net_type: getNetType(),
        u_net: FocusSDK.isPrivateNet() ? 2 : 1,
        status
      })
    );
  } catch (e) {
    console.error("analysisPerf err", e);
  }
}
